// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class AccountPayorRelationModel {
    static getAttributeTypeMap() {
        return AccountPayorRelationModel.attributeTypeMap;
    }
}
AccountPayorRelationModel.discriminator = undefined;
AccountPayorRelationModel.additionalProperties = false;
AccountPayorRelationModel.attributeTypeMap = [
    {
        "name": "roleType",
        "baseName": "roleType",
        "type": "AccountRoleType"
    },
    {
        "name": "accountRelations",
        "baseName": "accountRelations",
        "type": ""
    },
];
//# sourceMappingURL=accountPayorRelationModel.js.map